import { useStore } from '@nanostores/react';
import { authStore } from '@/services/auth/store';

/** Analytics is suppressed while masquerading as a customer. */
export function useIsAnalyticsEnabled(): boolean {
  const auth = useStore(authStore);
  return auth.account?.is_masq !== true;
}
